<template>
  <user-card class="user-card">
    <template v-slot:body>
      <p class="file-error">{{fileError}}</p>
      <!-- {{ dataFiles }} -->
      <section class="container-tab rel">
        <table>
          <tr>
            <td v-for="file in dataFiles" :key="file.id" class="custom-i">
              <a :href="rootUrl + file.fileLink" target="_blank" :title="file.fileName">
                <i :class="fileIcon(file.fileExtension)"></i>
                <span>{{ file.fileName }}</span>
              </a>
            </td>
          </tr>
        </table>
      </section>
      
    </template>
  </user-card>
</template>

<script>
import UserCard from "@/pages/UserProfileTeamplate/UserCard.vue";
import GlobalRequest from "@/plugins/globalRequest"
export default {
  components: {
    UserCard,
    GlobalRequest
  },
  name: 'EditFiles',
  props: ["dataFiles", "isAdmin", "id", "page"],
  // props: {
  //   dataFiles: { type: Object, required: true },
  //   isAdmin: { type: Boolean },
  //   id: { type: Number },
  //   page: { type: String },
  // },
  data() {
    return {
      fileError: "",
      filelist: [],
      File: [],
      rootUrl: process.env.VUE_APP_FILE_URL
    }
  },
  methods: {
    addFiles(e) {
      this.fileError = ""
      this.filelist= Array.from(this.filelist).concat(Array.from(e.target.files))
      console.log(this.filelist)
    },

    dragFile(e) {
      this.fileError = ""

      // проверка на совпадение имен файлов
      let arrayFile = Array.from(e.dataTransfer.files)
      for(let i in arrayFile) {
        let file = arrayFile[i]
        let filterArray = this.filelist.filter((element) => element.name == file.name)        

        if(filterArray.length == 0) {
          let type = file.name.split(".").pop()
          if( type == 'txt' || type == 'pdf' || type == 'doc' || type == 'xls' || type == 'xlsx' || type == 'png' || type == 'jpg' || type == 'jpeg'){
            this.filelist= Array.from(this.filelist).concat(file)
          }
          else {
            this.fileError = "Запрещенный формат файла"
          }
        }
      }
    },

    async delFile(file, type) {
      if( type == 'new') {
        let obj = this.filelist.filter((element) => element.name != file.name);
        this.filelist = obj
      }
      else {
        let obj = this.dataFiles.filter((element) => element.realFileName != file.realFileName);
        this.dataFiles = obj
        let request = await GlobalRequest.request("/user/" + this.id + "/file/" + file.id + "/delete", "POST");
      }
      console.log(this.dataFiles)
    },

    async postFile() {
      let count = this.dataFiles.length
      let formdata = new FormData();
      for(let i in this.filelist) {
        if (typeof this.filelist[i] == "object") {
          count = count + 1
          this.filelist[i].realFileName = this.filelist[i].name
          this.filelist[i].id = count
          this.filelist[i].link = this.filelist[i].filePath
          this.filelist[i].fileExtension = this.filelist[i].name.split(".").pop()
          let file = this.filelist[i]
          formdata.append("", file);
        }
      }
      this.$emit("saveFile", formdata);
      // await GlobalRequest.request("/" + this.page + "/" + this.id + "/file/upload", "POST", formdata, "multipart/form-data");

      this.dataFiles = this.dataFiles.concat(this.filelist);
      console.log(this.dataFiles)
      this.filelist = []
      
    },

    getFileIconClass(ext) {
      const e = (ext || "").toLowerCase();
      if (e === "doc" || e === "docx") return "fa fa-file-word-o";
      if (e === "xls" || e === "xlsx") return "fa fa-file-excel-o";
      if (e === "png" || e === "jpg" || e === "jpeg") return "fa fa-file-image-o";
      if (e === "pdf") return "fa fa-file-pdf-o";
      if (e === "txt") return "fa fa-file-text-o";
      return "fa fa-file-o";
    },

    fileIcon(ext) {
      const map = {
        doc: "fa fa-file-word-o",
        docx: "fa fa-file-word-o",
        xls: "fa fa-file-excel-o",
        xlsx: "fa fa-file-excel-o",
        jpg: "fa fa-file-image-o",
        jpeg: "fa fa-file-image-o",
        png: "fa fa-file-image-o",
        pdf: "fa fa-file-pdf-o",
      };
      return map[ext] || "fa fa-file-o";
    },

  },
}
</script>

<style scoped>

</style>
